import widget from './widget.json' with { type: 'json' }

export default { widget }
